/* eslint-disable */

import React, { useState } from "react";
import styled from "styled-components";
import GlobalStyles from "../Styles/Index";
import { SimpleTextInput } from "../Input/Index";

import SmallPackageIcon from "../../assets/Icons/small_size_package.svg";
import MediumPackageIcon from "../../assets/Icons/medium_package.svg";
import ExtraLargePackageIcon from "../../assets/Icons/extra_large_package.svg";
import ContainerIcon from "../../assets/Icons/container_package.svg";
import { IconIMG } from "../Images/Index";
import { PrimaryButton } from "../Button/Index";
import { Colors } from "../../assets/Res/Colors";

const NormalText = styled.div`
  font-family: Helvetica;
  font-size: 1rem;
  text-align: left;
  opacity: 0.6;
  padding: 5px 0px 5px 0px;
`;

const FlexedWrapper = styled.div`
  width: ${(props) => (props.width ? props.width : "48%")};

  @media (max-width: 1400px) {
    width: ${(props) => (props.smallWidth ? props.smallWidth : props.width)};
    flex-direction: ${(props) => (props.invert ? "column" : "row")};
    align-items: ${(props) => (props.invert ? "flex-start" : "row")};
    justify-content: ${(props) => (props.invert ? "space-between" : "row")};
  }
`;
const FaintText = styled.div`
  font-family: Helvetica;
  font-size: 0.6rem;
  opacity: 0.3;
`;

const ShipmentForm = ({ payload, handleChange, getQuote }) => {
  const [container, setContainer] = useState();

  return (
    <>
      <Wrapper>
        <FlexedWrapper
          width={"100%"}
          invert={true}
          style={{ ...GlobalStyles.HorizontalFlex }}
        >
          <FlexedWrapper
            width={"50%"}
            smallWidth={'100%'}
            style={{ ...GlobalStyles.HorizontalFlex }}
          >
            <FlexedWrapper width={"50%"}>
              <NormalText>Item Weight</NormalText>
              <SimpleTextInput width={"75%"}
                placeholder={"kg / grams"}
                type={'number'}
                value={payload.weight}
                onChange={(e) => handleChange('weight', e.target.value)} />
            </FlexedWrapper>
            <FlexedWrapper width={"50%"}>
              <NormalText>Item Length</NormalText>
              <SimpleTextInput
                width={"75%"}
                placeholder={"cm"} />
            </FlexedWrapper>
          </FlexedWrapper>
          <FlexedWrapper
            width={"50%"}
            smallWidth={'100%'}
            style={{ ...GlobalStyles.HorizontalFlex }}
          >
            <FlexedWrapper width={"50%"}>
              <NormalText>Item Width</NormalText>
              <SimpleTextInput width={"75%"} placeholder={"cm"} />
            </FlexedWrapper>
            <FlexedWrapper width={"50%"}>
              <NormalText>Item Height</NormalText>
              <SimpleTextInput width={"75%"} placeholder={"cm"} />
            </FlexedWrapper>
          </FlexedWrapper>
        </FlexedWrapper>

        <FlexedWrapper
          width={"100%"}
          invert={true}
          style={{ ...GlobalStyles.HorizontalFlex, marginTop: "2vh" }}
        >
          <FlexedWrapper
            width={"48%"}
            smallWidth={'100%'}
            style={{
              ...GlobalStyles.HorizontalFlex,
              justifyContent: "space-evenly",
            }}
          >
            <FlexedWrapper
              onClick={() => {
                setContainer("Small Size");
                handleChange('container', 'Small Size')
              }}
              width={"35%"}
              style={{
                borderRadius: "30px",
                backgroundColor: "#D9D9D966",
                padding: "15px",
                margin: '10px 0px 10px 0px',
                border: container === "Small Size" ? `2px solid ${Colors.RED}` : ""
              }}
            >
              <IconIMG
                icon={SmallPackageIcon}
                width={"100px"}
                height={"100px"}
              />
              <NormalText>30x20x15</NormalText>
              <FaintText>Small Size</FaintText>
            </FlexedWrapper>
            <FlexedWrapper
              onClick={() => {
                setContainer('Extra Large Size');
                handleChange('container', 'Extra Large Size')
              }}
              width={"35%"}
              style={{
                borderRadius: "30px",
                backgroundColor: "#D9D9D966",
                padding: "15px",
                margin: '10px 0px 10px 0px',
                border: container === "Extra Large Size" ? `2px solid ${Colors.RED}` : ""
              }}
            >
              <IconIMG
                icon={ExtraLargePackageIcon}
                width={"100px"}
                height={"100px"}
              />
              <NormalText>25x12x7</NormalText>
              <FaintText>Extra Large</FaintText>
            </FlexedWrapper>
          </FlexedWrapper>
          <FlexedWrapper
            width={"50%"}
            smallWidth={'100%'}
            style={{
              ...GlobalStyles.HorizontalFlex,
              justifyContent: "space-evenly",
            }}
          >
            <FlexedWrapper
              onClick={() => {
                setContainer('Medium Size');
                handleChange('container', 'Medium Size')
              }}
              width={"35%"}
              style={{
                borderRadius: "30px",
                backgroundColor: "#D9D9D966",
                padding: "15px",
                margin: '10px 0px 10px 0px',
                border: container === "Medium Size" ? `2px solid ${Colors.RED}` : ""
              }}
            >
              <IconIMG
                icon={MediumPackageIcon}
                width={"100px"}
                height={"100px"}
              />
              <NormalText>23x14x4</NormalText>
              <FaintText>Medium Size</FaintText>
            </FlexedWrapper>
            <FlexedWrapper
              onClick={() => {
                setContainer('Large Size');
                handleChange('container', 'Large Size')
              }}
              width={"35%"}
              style={{
                borderRadius: "30px",
                backgroundColor: "#D9D9D966",
                padding: "15px",
                margin: '10px 0px 10px 0px',
                border: container === "Large Size" ? `2px solid ${Colors.RED}` : ""
              }}
            >
              <IconIMG icon={ContainerIcon} width={"100px"} height={"100px"} />
              <NormalText>600x150</NormalText>
              <FaintText>Container</FaintText>
            </FlexedWrapper>
          </FlexedWrapper>
        </FlexedWrapper>

        <PrimaryButton
          width={"15%"}
          text={"Get quote"}
          color={"#ffffff"}
          padding={"7px"}
          smallWidth={'40%'}
          onClick={() => getQuote()}
        />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  border-radius: 10px;
  background-color: #d9d9d933;
  padding: 25px 10px 25px 10px;
  width: 100%;
  margin: 2vh 0px 2vh 0px;
`;

export default ShipmentForm;
